"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DateTimeBridge_1 = require("./DateTimeBridge");
class DateTimeBridgeMock extends DateTimeBridge_1.DateTimeBridgeImpl {
    constructor() {
        super();
        this.setSystemFormat({
            dateTime: "YYYY-MM-DD HH:mm:ss",
            date: "YYYY-MM-DD",
            time: "HH:mm:ss",
        });
        this.setUserFormat({
            dateTime: "DD-MM-YYYY HH:mm:ss",
            date: "DD-MM-YYYY",
            time: "HH:mm:ss",
        });
    }
}
exports.default = DateTimeBridgeMock;
//# sourceMappingURL=DateTimeBridgeMock.js.map